import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { UserContext } from '../context api/UserContext'
import { ROUTES } from '../shared/constants'
import { doesTokenExist } from './TokenHelper'

const PrivateRoute = ({ children, ...rest }) => {
  const user = useContext(UserContext)
  const token = user && user.token

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!doesTokenExist(token)) {
          return (
            <Redirect
              to={{
                pathname: ROUTES.HOME,
                state: { from: location },
              }}
            />
          )
        }
        return children
      }}
    />
  )
}

export default PrivateRoute
